<template>
    <div>
        <or-page-title>Контакты</or-page-title>
        <div class="layout-1200 flex-column column-hor-center">
            <div class="title flex-row">
                <p class="text">{{info['phone-text']}}</p>
                <p class="phone">{{info['phone']}}</p>
            </div>
            <div class="map">
                <div class="ymap">
                    <div id="map" style="width: 1200px; height: 600px;">
                        <!-- <yandex-map :settings="settings"></yandex-map> -->
                    </div>
                </div>
                <div class="map-info">
                    <div class="info flex-row">
                        <p class="info-title">Адрес:</p>
                        <p class="info-text" v-html="text"></p>
                    </div>
                    <div class="info flex-row">
                        <p class="info-title">Телефон:</p>
                        <p class="info-text">{{info['phone']}}</p>
                    </div>
                    <div class="info flex-row">
                        <p class="info-title">Телефон директора:</p>
                        <div class="info-text-container flex-row">
                            <p class="info-text">{{info['phone-1']}}</p>
                        </div>
                    </div>
                    <div class="info flex-row">
                        <p class="info-title">Телефон коммерческого директора:</p>
                        <div class="info-text-container flex-row">
                            <p class="info-text">{{info['phone-2']}}</p>
                        </div>
                    </div>
                    <div class="info flex-row">
                        <p class="info-title">Телефон технического директора:</p>
                        <div class="info-text-container flex-row">
                            <p class="info-text">{{info['phone-3']}}</p>
                        </div>
                    </div>
                    <div class="info flex-row">
                        <p class="info-title">Директор:</p>
                        <p class="info-text">{{info['director']}}</p>
                    </div>
                </div>
            </div>
        </div>
        <or-feedback :settings="fb_settings" id="feedback"/>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import orPageTitle from '../global/or-page-title.vue'
import orFeedback from '../global/or-feedback.vue'

export default {
    components: {orPageTitle, orFeedback},
    props: {
        fb_settings: Object,
    },
    mounted() {
        const initYMaps = () => {
            this.myMap = new ymaps.Map("map", {
                center: [this.info.coords.split(',')[0], this.info.coords.split(',')[1]],
                zoom: 17,
                controls: ['zoomControl'],
            });
            this.placemark = new ymaps.Placemark([this.info.placemark.split(',')[0], this.info.placemark.split(',')[1]], {
                iconContent: 'ООО "Огнеупорные Решения"'
            }, {
                preset: "islands#yellowStretchyIcon",
            });
            this.myMap.geoObjects.add(this.placemark);
        }
        this.changeIsPageReady({is: true})
        const checkMap = setInterval(()=>{
            try {
                initYMaps();
                clearInterval(checkMap);
            } catch(error) {
                console.log('ymaps loading...');
            }
        },200);
    },
    unmounted() {
        this.myMap = null;
        this.placemark = null;
    },
    computed: {
        ...mapGetters({info: 'getInfo'}),
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.info.adress, container: div});
            return div.innerHTML;
        }
    },
    methods: {
        ...mapActions({changeIsPageReady: 'changeIsPageReady', convertText: 'convertText'}),
    }
}
</script>

<style>
.ymaps-2-1-77-zoom {
    position: relative;
    right: -1140px;
    top: 88px;
    }
</style>

<style scoped>
    .title {
        padding: 50px 0;
        box-sizing: border-box;
    }
    .text {
        font-size: 20px;
        line-height: 28px;
    }
    .phone {
        font-size: 20px;
        line-height: 28px;
        color: #EBB932;
        margin-left: 5px;
    }
    .map {
        position: relative;
        margin-bottom: 50px;
    }
    .ymap {
        width: 1200px;
        height: 600px;
        background-image: url('../../assets/ymap_fake.jpg');
        background-position: center;
        background-size: cover;
        border-radius: 8px;
        overflow: hidden;
    }
    .map-info {
        padding: 32px 30px 32px 20px;
        box-sizing: border-box;
        position: absolute;
        top: 40px;
        left: 40px;
        width: 368px;
        background-color: #1e1e1e;
        border-radius: 8px;
    }
    .info {
        position: relative;
        margin-bottom: 20px;
    }
    .info:last-of-type {
        margin-bottom: 0;
    }
    .info-title {
        width: 125px;
        font-size: 14px;
        line-height: 16px;
        color: #EBB932;
        text-align: right;
    }
    .info-text {
        width: 170px;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        margin-left: 10px;
    }
    .info-text-container {
        align-items: flex-end;
    }
</style>